export default "__VITE_ASSET__Sz2RDZEg__"